import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    ShareArticleApiParameter,
    ShareArticleModel,
    ShareArticleParameter,
    shareArticleService,
} from "@tCentro/Services/CENShareArticleService";

type HandlerType = ApiHandlerDiscreteParameter<ShareArticleParameter, ShareArticleApiParameter, ShareArticleModel>;

export const PopulateApiParameter: HandlerType = props => {
    const shareArticleModel = props.parameter as ShareArticleModel;
    props.apiParameter = { shareArticleModel };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await shareArticleService(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const shareArticle = createHandlerChainRunner(chain, "CENShareArtice");
export default shareArticle;
